import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export function sanitizeHtml(html: string) {
  return html.replace(/\s\$="[^"]*"/g, '');
}

export function toCamelCase(str: string) {
  if (typeof str !== 'string') return str;
  return str.replace(/_/g, '').replace(/(\b\w)/g, (char) => char.toUpperCase());
}

export const truncateCMSString = (str: string) => {
  const match = str.match(/<hr[^>]*>([\s\S]*)/);
  if (match && match[1]) {
    return match[1].trim();
  } else {
    return str;
  }
};

export const stripHTML = /(<([^>]+)>)/gi;
